export default __webpack_public_path__ + "static/media/trackid_logo.002f8f78.png";